import CryptoJS from "crypto-js";
import { ENV } from "../config/env";
import {
  clearStorage,
  getItemFromStorage,
  removeItemFromStorage,
} from "./storage";
import { emptyString } from "../constants";

const createAesConfig = () => ({
  key: CryptoJS.enc.Utf8.parse(ENV.CRYPTO_JS_KEY),
  options: {
    iv: CryptoJS.enc.Utf8.parse(ENV.CRYPTO_JS_IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  },
});

export const encryptObject = (object) => {
  const plaintext = JSON.stringify(object);
  const { key, options } = createAesConfig();
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, options);

  return encrypted.toString();
};

export const decryptObject = (encryptedString) => {
  try {
    if (encryptedString === emptyString) {
      return {};
    }
    const { key, options } = createAesConfig();
    const decrypted = CryptoJS.AES.decrypt(encryptedString, key, options);
    const obj = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(obj);
  } catch (e) {
    removeItemFromStorage(ENV.PAYLOAD);
    clearStorage();
    window.location.reload();
  }
};

// ------------------- Decrypt Payload
export const getDecryptPayload = () => {
  const encryptedPayload =
    getItemFromStorage(ENV.PAYLOAD) || emptyString;
  return decryptObject(encryptedPayload);
};

export const getToken = () => {
  const payload = getDecryptPayload();
  const tokenType = payload[ENV.TOKEN];
  // returning simple login token
  if (tokenType) {
    return tokenType;
  }
  // returning the encoded url token after routing
  return payload.response;
};
